import spacecase from 'root-core/utils/text/spacecase.js'
import format from 'root-core/utils/text/stringFormatFilter.js'
import striptags from 'striptags'

export const ensure = function (message, test) {
  return function (value, is, object, property) {
    if (!test.apply(undefined, arguments)) {
      return renderMessage(message, value, object, property)
    }
  }
}

export const required = function (message) {
  return ensure(
    message || ((value, object, property) => `${property} is required`),
    value => value
  )
}

export const oneOf = function () {
  var values = Array.prototype.slice.call(arguments)
  return ensure(`must be one of ${values.join(', ')}`, value => values.indexOf(value) >= 0)
}

export const creditCardNumber = function () {
  return ensure(
    'must be a valid credit card number',
    value => value && /^\d{4}-\d{4}-\d{4}-\d{4}$/.test(value.trim())
  )
}

export const optional = function (schema) {
  return ensure('', (value, ensure) => {
    if (value) {
      ensure(schema)
    }
  })
}

export const notags = function (errorMessage, field) {
  return function (value, is, object, property) {
    if (value !== striptags(value)) {
      return format(errorMessage, field || spacecase(property))
    }
  }
}

function renderMessage (message, value, object, property) {
  return typeof message === 'function'
    ? message(value, object, property)
    : message
}
